// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/support.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/support.tsx");
  import.meta.hot.lastModified = "1730642741830.035";
}
// REMIX HMR END

import { motion } from "framer-motion";
import { fadeIn } from "~/lib/variants";
import { Link } from "@remix-run/react";
import { Button } from "~/components/ui/button";
export const meta = () => {
  return [{
    title: "پشتیبانی XRayBOX"
  }, {
    name: "description",
    content: `تیم پشتیبانی مجموعه XRay Box بصورت 24 ساعته در تمامی روزهای هفته آماده
      کمک و حل مشکلات کاربران عزیز میباشد. برای گرفتن خدمات روتر از پشتیبانی
      ارائه دو عددی که بر روی جعبه آن نوشته شده به پشتیبانی الزامیست. یکی از
      این اعداد شماره سرور و دیگری شماره آیپی اکانت دستگاه میباشد.
      `
  }, {
    name: "robots",
    content: "index, follow"
  }, {
    name: "og:image",
    content: "/assets/img/xraybox.png"
  }];
};
export default function SupportIndex() {
  return <div className="h-full bg-no-repeat bg-cover bg-center">
      {/* section 6 support */}
      <section className="w-full pt-20 px-4 mx-auto md:container" id="support">
        <motion.h2 variants={fadeIn("down", 0.2, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className=" px-1 py-3 text-3xl text-violet-500 md:text-4xl font-bold tracking-tight transition-colors">
          پشتیبانی
        </motion.h2>
        <motion.p variants={fadeIn("right", 0.4, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-3 text-base md:text-lg">
          تیم پشتیبانی XRay Guard بصورت 24 ساعته در تمامی روزهای هفته آماده کمک
          و حل مشکلات کاربران عزیز میباشد. <br />
          برای گرفتن خدمات از پشتیبانی ارائه دو عدد که هنگام خرید بر روی جعبه
          کالا نوشته شده الزامیست. <br />
          یکی از این اعداد شماره سرور و دیگری شماره آیپی اکانت دستگاه در آن سرور
          میباشد.
        </motion.p>
        <motion.p variants={fadeIn("right", 0.4, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-3 text-base md:text-lg">
          چنانچه کد دستگاه خود را فراموش نموده اید و یا به جعبه آن دسترسی ندارید
          میتوانید با ارسال مک آدرس دستگاه به پشتیبانی کد دستگاه خود را گرفته و
          در محلی نگهداری نمایید.
        </motion.p>
        <motion.p variants={fadeIn("right", 0.4, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-3 text-base md:text-lg">
          یکی از امکانات منحصربفرد این روترها امکان ریموت شدن بر روی آنها و حل
          مشکلات و تنظیمات نرم افزاری بدون نیاز به حضور کارشناس در محل میباشد.{" "}
          <br /> لذا در صورت مواجه شدن با مشکل ، تیم پشتیبانی از طریق ریموت به
          سرعت مشکل دستگاه را شناسایی و آن را رفع مینماید.
        </motion.p>
        <motion.p variants={fadeIn("right", 0.5, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-3 text-base md:text-lg">
          از آنجاییکه با کوچکترین تغییری در تنظیمات دستگاه ارتباط گروه پشتیبانی
          با روتر قطع میگردد و دیگر امکان ارائه خدمات امکان پذیر نمیباشد لذا
          پسورد پنل روتر در اختیار کاربران قرارداده نمیشود تا بدین وسیله تا از
          هرگونه دخل و تصرف در تنظیمات روتر جلوگیری به عمل آید.
        </motion.p>
        <motion.p variants={fadeIn("right", 0.6, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-3 text-base text-center md:text-lg">
          برای ورود به پشتیبانی کلید زیر را لمس نمایید.
        </motion.p>
        <motion.div variants={fadeIn("left", 0.7, 1.3)} initial="hidden" whileInView="show" viewport={{
        once: true
      }} exit="hidden" className=" my-4 mx-auto text-center">
          <Link to="https://t.me/xrayguard" title="پشتیبانی تلگرام">
            <Button size="lg">پشتیبانی تلگرام</Button>
          </Link>
        </motion.div>
      </section>
    </div>;
}
_c = SupportIndex;
var _c;
$RefreshReg$(_c, "SupportIndex");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;